import { useMemo } from "react";

import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Box } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { useElementSize } from "app/pages/market-research/hooks/useElementSize";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import { useKeywordListComposerContext } from "../KeywordListComposerContext";
import { KeywordListComposerKeywordList } from "../KeywordListComposerKeywordList";
import { trackPopupClick } from "../tracking";

import { TotalMatchingKeywords } from "./TotalMatchingKeywords";

const { carbon } = colorsPalettes;

const Title = styled.div`
    ${setFontVariant("sectionTitle", carbon[250])};
    padding: 12px 16px;
`;
const Container = styled(FlexColumn)`
    flex: 1 1 auto;
`;

export const MatchingKeywords = () => {
    const [wrapperRef, wrapperSize] = useElementSize();
    const { query, keywords, bulkEditMode, removeKeywords, selectKeywords, deselectAllKeywords } =
        useKeywordListComposerContext();
    const regex = useMemo(() => new RegExp(query, "i"), [query]);
    const matchingKeywords = useMemo(() => keywords.filter((keyword) => regex.test(keyword.term)), [keywords, regex]);
    const semiSelected = bulkEditMode && matchingKeywords.some(({ selected }) => !selected);

    const handleBulkEditCheckboxClick = () => {
        if (bulkEditMode) {
            deselectAllKeywords();
            trackPopupClick({ event: "uncheck", count: matchingKeywords.length });
        } else {
            selectKeywords(matchingKeywords, true);
            trackPopupClick({ event: "check", count: matchingKeywords.length });
        }
    };

    if (matchingKeywords.length === 0) {
        return null;
    }

    return (
        <Container>
            <Title>{translate("auto.keyword.list.generator.body.suggestions.mathching.keywords.title")}</Title>
            <TotalMatchingKeywords
                keywords={matchingKeywords}
                selected={bulkEditMode}
                onClick={handleBulkEditCheckboxClick}
                semiSelected={semiSelected}
            />
            <Box
                flexGrow="1"
                ref={wrapperRef}
            >
                <KeywordListComposerKeywordList
                    width={wrapperSize.width}
                    height={wrapperSize.height}
                    query={query}
                    keywords={matchingKeywords}
                    onSelectKeyword={selectKeywords}
                    onDeleteKeyword={removeKeywords}
                />
            </Box>
        </Container>
    );
};
